import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/icon/variable/arrow-double.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/variable/arrow-right.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/variable/date.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/variable/logo.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/variable/quotation.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/variable/social/facebook.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/variable/social/linkedin.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/variable/social/whatsapp.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/variable/social/x.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/article/subscribe-bg.webp");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(layout)/blog/[slug]/_modules/breadcrumb/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/banner/carousel/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/layout/header/mobileMenu/content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/header/sticky/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/links/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/share/facebook/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/share/linkedin/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/share/whatsapp/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/share/x/index.tsx");
